export const range = (length: number, start = 0) => {
    return Array.from(new Array(length)).map((_v, i) => i + start);
};
